import { ValidationButton } from '@axafr-btc-ds/buttons';

import { NextButtonProps } from './NextButton.interface';
import styles from './NextButton.module.css';

export function NextButton({
    isDisabled,
    nextScreens = [],
    onClick,
}: NextButtonProps): JSX.Element {
    return (
        <ValidationButton
            className={ styles.host }
            isDisabled={ isDisabled }
            onClick={ onClick }
            onMouseOver={ () => {
                nextScreens.forEach((screen) => screen.preload());
            } }
        >
            Étape suivante
        </ValidationButton>
    );
}
